<div
  style="overflow-y: auto"
  mdbModal
  #fiaSdaModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="fiaSdaModalLabel"
  aria-hidden="true"
>
  <form #fiaSdaForm="ngForm" (ngSubmit)="saveClicked(fiaSdaForm)" name="fiaSdaForm" class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <div>
          <h3 class="text-center font-weight-bold">Edit FIA Pins & SDA</h3>
          <h5 class="text-center text-muted" *ngIf="transaction">{{ transaction.fullName }} (ID: {{ transaction.id }})</h5>
        </div>
      </div>

      <div class="modal-body">
        <div *ngIf="loadingData" class="text-center py-5">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="mt-3">{{ busyText }}</p>
        </div>

        <!-- Save Error Alert -->
        <div *ngIf="showSaveError" class="alert alert-danger mb-3" role="alert">
          <strong><i class="fas fa-exclamation-circle"></i> Error:</strong> {{ saveError }}
        </div>

        <div *ngIf="!loadingData && !showSaveError">
          <!-- Summary Section -->
          <div class="row mb-3">
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <h6 class="text-muted">Total Trade Amount</h6>
                  <h4 class="font-weight-bold">R {{ totalTradeAmount | number: "1.0-0" }}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <h6 class="text-muted">Total Allocated</h6>
                  <h4
                    class="font-weight-bold"
                    [class.text-success]="remainingToAllocate === 0"
                    [class.text-danger]="remainingToAllocate !== 0"
                  >
                    R {{ totalAllocated | number: "1.0-0" }}
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <h6 class="text-muted">Remaining</h6>
                  <h4
                    class="font-weight-bold"
                    [class.text-success]="remainingToAllocate === 0"
                    [class.text-warning]="remainingToAllocate > 0"
                    [class.text-danger]="remainingToAllocate < 0"
                  >
                    R {{ remainingToAllocate | number: "1.0-0" }}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <!-- Validation Warning -->
          <div *ngIf="showValidationWarning" class="alert alert-warning mb-3" role="alert">
            <strong><i class="fas fa-exclamation-triangle"></i> Validation Error:</strong> {{ validationError }}
          </div>

          <!-- SDA and Pins Table -->
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-bordered table-hover" mdbTable>
                <thead class="thead-light">
                  <tr>
                    <th style="width: 25%">Pin / SDA</th>
                    <th style="width: 20%" class="text-right">Available Balance</th>
                    <th style="width: 15%" class="text-center">Actions</th>
                    <th style="width: 20%" class="text-right">Amount Used</th>
                    <th style="width: 20%" class="text-right">New Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- SDA Row -->
                  <tr class="sda-row">
                    <td>
                      <strong [class.text-success]="editableSdaAmount > 0">SDA</strong>
                    </td>
                    <td class="text-right">R {{ remainingSdaAvailable | number: "1.0-0" }}</td>
                    <td class="text-center">
                      <button
                        *ngIf="remainingToAllocate > 0 && editableSdaAmount <= 0"
                        type="button"
                        mdbBtn
                        color="light"
                        size="sm"
                        class="m-0 px-2"
                        (click)="fillSda()"
                        mdbTooltip="Fill remaining amount with SDA"
                      >
                        <i class="fas fa-fill"></i> Fill
                      </button>
                      <button
                        *ngIf="editableSdaAmount > 0"
                        type="button"
                        mdbBtn
                        color="light"
                        size="sm"
                        class="m-0 px-2"
                        (click)="clearSda()"
                        mdbTooltip="Clear SDA amount"
                      >
                        <i class="fas fa-times"></i> Clear
                      </button>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control form-control-sm text-right no-spinner"
                        [(ngModel)]="editableSdaAmount"
                        name="sdaAmount"
                        mdbInput
                        mdbValidate
                        min="0"
                        [max]="remainingSdaAvailable"
                        step="0.01"
                        (focus)="$event.target.select()"
                        (change)="updateTotals()"
                        [class.is-invalid]="editableSdaAmount < 0 || editableSdaAmount > remainingSdaAvailable"
                      />
                    </td>
                    <td class="text-right">R {{ remainingSdaAvailable - (editableSdaAmount || 0) | number: "1.0-0" }}</td>
                  </tr>

                  <!-- Pin Rows -->
                  <tr *ngFor="let pin of editablePins; trackBy: trackByPinId">
                    <td>
                      <span class="font-weight-bold" [class.text-success]="pin.amountUsed > 0">{{ pin.pin }}</span>
                    </td>
                    <td class="text-right">R {{ pin.pinBalance | number: "1.0-0" }}</td>
                    <td class="text-center">
                      <button
                        *ngIf="remainingToAllocate > 0 && pin.amountUsed <= 0"
                        type="button"
                        mdbBtn
                        color="light"
                        size="sm"
                        class="m-0 px-2"
                        (click)="fillPin(pin)"
                        mdbTooltip="Fill with this pin"
                      >
                        <i class="fas fa-fill"></i> Fill
                      </button>
                      <button
                        *ngIf="pin.amountUsed > 0"
                        type="button"
                        mdbBtn
                        color="light"
                        size="sm"
                        class="m-0 px-2"
                        (click)="clearPin(pin)"
                        mdbTooltip="Clear this pin"
                      >
                        <i class="fas fa-times"></i> Clear
                      </button>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control form-control-sm text-right no-spinner"
                        [(ngModel)]="pin.amountUsed"
                        [name]="'pin_' + pin.userFiaPinId"
                        mdbInput
                        mdbValidate
                        min="0"
                        [max]="pin.pinBalance"
                        step="0.01"
                        (focus)="$event.target.select()"
                        (change)="updateTotals()"
                        [class.is-invalid]="pin.amountUsed < 0 || pin.amountUsed > pin.pinBalance"
                      />
                    </td>
                    <td class="text-right">R {{ pin.pinBalance - (pin.amountUsed || 0) | number: "1.0-0" }}</td>
                  </tr>

                  <!-- No Pins Message -->
                  <tr *ngIf="editablePins.length === 0">
                    <td colspan="5" class="text-center text-muted py-3">
                      <i class="fas fa-info-circle"></i> No FIA pins available for this user
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Footer Summary -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="card bg-light">
                <div class="card-body">
                  <div class="row">
                    <div class="col-4 text-center">
                      <small class="text-muted">Total FIA</small>
                      <div class="font-weight-bold">R {{ totalFiaAllocated | number: "1.0-0" }}</div>
                    </div>
                    <div class="col-4 text-center">
                      <small class="text-muted">Total SDA</small>
                      <div class="font-weight-bold">R {{ editableSdaAmount | number: "1.0-0" }}</div>
                    </div>
                    <div class="col-4 text-center">
                      <small class="text-muted">Grand Total</small>
                      <div
                        class="font-weight-bold"
                        [class.text-success]="remainingToAllocate === 0"
                        [class.text-danger]="remainingToAllocate !== 0"
                      >
                        R {{ totalAllocated | number: "1.0-0" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-end">
        <div *ngIf="!busy && !showSaveError">
          <button type="submit" mdbBtn color="trakly-action" class="relative waves-light" [disabled]="showValidationWarning || loadingData">
            <i class="fas fa-save"></i> Save
          </button>
          <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">
            <i class="fas fa-times"></i> Cancel
          </button>
        </div>
        <div *ngIf="showSaveError">
          <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">
            <i class="fas fa-times"></i> Cancel
          </button>
        </div>
        <div *ngIf="busy" class="text-center">
          <span class="mr-3">{{ busyText }}</span>
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
